/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const CarrierType = {
    Universal: 'Universal',
    Truck: 'Truck',
    Vessel: 'Vessel',
    Train: 'Train',
    Unknown: 'Unknown',
} as const;

export type CarrierType = typeof CarrierType[keyof typeof CarrierType];



